import { FIX_BROKEN_ROUTE_SUCCESS, FIX_BROKEN_ROUTE_ERROR } from './MiddlewareRoute.actions'

const initialState = {
  redirectTo: null,
  calculating: true
}

/**
 * The route middleware reducer.
 */
const middlewareRouteReducer = (state = initialState, action) => {
  switch (action.type) {
    case FIX_BROKEN_ROUTE_SUCCESS:
      return {
        ...state,
        redirectTo: action.payload,
        calculating: false
      }
    case FIX_BROKEN_ROUTE_ERROR:
      return {
        ...state,
        redirectTo: null,
        calculating: false
      }
    default:
      return state
  }
}

export default middlewareRouteReducer
